import Vue from "vue";

import i18n from "@/i18n";
import CommonUtil from "@/utils/commonutil.js";
Vue.filter("Translate", value => i18n.t(value));
Vue.filter("getText", CommonUtil.getText);
